import script from "./ContactEmprendimiento.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactEmprendimiento.vue?vue&type=script&setup=true&lang=js"

import "./ContactEmprendimiento.vue?vue&type=style&index=0&id=27f16808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27f16808"]])

export default __exports__